// extracted by mini-css-extract-plugin
export default {"container":"Top_container__77Lm3","icon":"Top_icon__X27ef"};